var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#0071BC",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5334_19395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3625 9.59119L8.2565 23.1252C8.08939 23.4146 8.00096 23.7427 8.00001 24.0768C7.99905 24.411 8.0856 24.7396 8.25104 25.0299C8.41649 25.3203 8.65506 25.5622 8.94304 25.7317C9.23101 25.9013 9.55835 25.9924 9.8925 25.9962H26.1065C26.4405 25.9923 26.7677 25.9011 27.0555 25.7317C27.3433 25.5622 27.5818 25.3204 27.7472 25.0302C27.9126 24.74 27.9992 24.4116 27.9984 24.0776C27.9976 23.7435 27.9094 23.4155 27.7425 23.1262L19.6365 9.59019C19.466 9.30869 19.2257 9.07593 18.9389 8.91439C18.6522 8.75284 18.3286 8.66797 17.9995 8.66797C17.6704 8.66797 17.3468 8.75284 17.06 8.91439C16.7733 9.07593 16.533 9.30869 16.3625 9.59019V9.59119Z",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15H18.01",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18H18V22H19",
    stroke: "#0071BC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5334_19395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a37771bed22dfceca8916bb8ee7edd49.svg";
export { ForwardRef as ReactComponent };